import React from 'react';

import { mode } from "webconfig";
import UploadCompleted from '@/Common/UploadCompleted/UploadCompleted'
import i18n from '../i18n';
import { Redirect } from 'react-router-dom';
export class PaymentCompletedPage extends React.Component {
  state = {
    SuccessperPayment : false,
    SuccessSubscriptionPayment: false,
  }
  perPaymentSuccess = (history, info) => {
    this.setState({
      SuccessperPayment: true
    })
    //console.log('편당 결제에 성공 하였습니다. 편집창으로 이동합니다');
    const { templateId, videoId } = info;
    history.push({
      pathname: `/makevideo`,
      search: `?id=${videoId}`
    });
  };

  subscriptionPaymentSuccess = history => {    
    // console.log(
    //   '정기 결제에 성공 하였습니다. 디자인 고르기 페이지에서 원하는 템플릿을 찾아보세요!'
    // );
    this.setState({
      SuccessSubscriptionPayment : true
    })
    history.push(`/designSelect`);
  };
  SuccessperPayment = ()=>()=>{
    this.setState({
      SuccessperPayment : false
    })
  }
  SuccessSubscriptionPayment = ()=>()=>{
    this.setState({
      SuccessSubscriptionPayment : false
    })
  }

  render() {
    const { history, location } = this.props;
    if (!location.state || !location.state.info) {
      history.push("/payment")
      return null
    }
    const { info } = location.state;
    if (info.type === 'PerPayment') {
      this.perPaymentSuccess(history, info);
    }

    if (info.type === 'TermPayment') {
      this.subscriptionPaymentSuccess(history);
    }

    if (info.type === 'SubscriptionPayment') {
      this.subscriptionPaymentSuccess(history);
    }
    if (info.type === "IssueCoupon") {
      this.subscriptionPaymentSuccess(history)
    }

    return (
          <div>
            <div>처리중</div>
          <UploadCompleted
          DesignedButtonText={i18n.t("global.confirm")}
          dialogBodyText1={i18n.t("PaymentCompletedPage.UploadCompleted.dialogBodyText1_1")}
          dialogHeadText={i18n.t("global.alert")}
          open={this.state.SuccessSubscriptionPayment}
          closeUploadCompletedDialog={this.SuccessSubscriptionPayment}
          closeBtn={this.handleClose}
        />
          <UploadCompleted
          DesignedButtonText={i18n.t("global.confirm")}
          dialogBodyText1={i18n.t("PaymentCompletedPage.UploadCompleted.dialogBodyText1_2")}
          dialogHeadText={i18n.t("global.alert")}
          open={this.state.SuccessperPayment}
          closeUploadCompletedDialog={this.SuccessperPayment}
          closeBtn={this.handleClose}
        />
          </div>
    );
  }
}
